import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { BRAND } from "../data/siteData";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/blog", label: "Blog" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Logo = ({ variant = "light", className = "h-10 md:h-12" }) => (
  <Link to="/" data-testid="header-logo" className="flex items-center select-none shrink-0">
    <img
      src={variant === "light" ? BRAND.logoLight : BRAND.logoColor}
      alt="Vantyx Coatings — Phoenix garage floor coating"
      className={`${className} w-auto object-contain`}
    />
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 w-full z-50 backdrop-blur-xl bg-[#000000]/90 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 md:h-24 flex items-center justify-between">
        <Logo variant="light" className="h-12 md:h-14" />
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-200 ${isActive ? "text-[#028090]" : "text-gray-300 hover:text-white"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3 md:gap-5">
          <a href={BRAND.phoneHref} data-testid="header-phone-link" className="hidden sm:flex items-center gap-2 text-white font-semibold text-sm hover:text-[#028090] transition-colors duration-200">
            <Phone size={16} className="text-[#028090]" strokeWidth={1.5} />
            {BRAND.phone}
          </a>
          <a href={BRAND.phoneHref} data-testid="header-phone-mobile" className="sm:hidden text-[#028090]" aria-label="Call us">
            <Phone size={20} strokeWidth={1.5} />
          </a>
          <Link
            to="/free-estimate"
            data-testid="header-free-estimate-btn"
            className="bg-[#028090] text-white hover:bg-[#026c7a] transition-colors duration-300 px-4 md:px-6 py-2.5 uppercase font-bold tracking-wider text-xs md:text-sm whitespace-nowrap"
          >
            Free Quote
          </Link>
          <button className="lg:hidden text-white" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden bg-[#000000] border-t border-white/10 px-6 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${n.label.toLowerCase()}`} className="text-gray-200 font-medium py-1">
              {n.label}
            </NavLink>
          ))}
          <a href={BRAND.phoneHref} className="text-[#028090] font-bold">{BRAND.phone}</a>
        </nav>
      )}
    </header>
  );
};
